import { getAcceptableParams } from '@/helpers/formatters';

const dateRange = ['from', 'to'];
const dateWeek = ['week'];

export const featureQueryParams = [
  'tab',
  'source_open_category',
  'req_table_sort',
  'is_gender_table',
  'general_vs_niche',
  'is_post_revisions_score',
  'view',
];

export const actionableInsightsUrls = [
  'employer-brand-report',
  'compliance-report',
  'job-performance-report',
];

export const nonAnalyticsEngineUrls = [
  'weekly-snapshot',
  'usage',
  'content-snapshot',
  'language-snapshot',
  'recruiting-performance',
  ...actionableInsightsUrls,
];

export const getIgnorableUrlParams = (routeName) => ({
  'weekly-snapshot': [...dateRange, 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'content-snapshot': [...dateRange, 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'language-snapshot': [...dateRange, 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'overall-report': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'inbound-report': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'is_post_revisions_score', 'templates'],
  'outbound-report': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'drop-off': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'pass-through': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'hiring-report': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'gender-report': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'executive-insights': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'recruiting-performance': ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  usage: ['week', 'internal', 'tab', 'source_open_category', 'req_table_sort', 'is_gender_table', 'general_vs_niche', 'templates'],
  'demographic-survey-report': ['week', 'internal', 'general_vs_niche', 'is_post_revisions_score', 'templates'],
  'compliance-report': ['templates'],
  'job-performance-report': ['templates'],
})[routeName] || dateWeek;

export const getReportingQueryParam = (route, routeName) => {
  const { page, sort, ...params } = route.query;
  const ignoreParams = getIgnorableUrlParams(routeName);

  // Keep reporting and analytics in case of redirects
  if (route.path.includes('/analytics/') || route.path.includes('/reporting/') || route.path.includes('/insights/')) {
    // Going from app db page to analytics engine page
    // and vice versa should only share a few filters
    if (nonAnalyticsEngineUrls.includes(route.name)
        !== nonAnalyticsEngineUrls.includes(routeName)) {
      const finalParams = {};

      // We only persist dates on non-actionable insights pages
      if (params.from
          && !actionableInsightsUrls.includes(routeName)) finalParams.from = params.from;
      if (params.to && !actionableInsightsUrls.includes(routeName)) finalParams.to = params.to;

      if (params.owned) finalParams.owned = params.owned;

      return finalParams;
    }

    return getAcceptableParams({ params, ignoreParams });
  }

  return {};
};
